export interface IVfxTask
{
  onUpdate( now: number ): boolean; // returns true if finished
}

export class VfxTaskRunner
{
  private static tasks: IVfxTask[] = [];

  public static addTask( task: IVfxTask ): void
  {
    this.tasks.push( task );
  }

  public static getTasks(): ReadonlyArray<IVfxTask>
  {
    return this.tasks;
  }

  public static update( now: number ): void
  {
    for ( let i = this.tasks.length - 1; i >= 0; i-- )
      if ( this.tasks[i].onUpdate( now ) )
        this.tasks.splice( i, 1 );
  }

  public static clear(): void
  {
    this.tasks = [];
  }

  public static hasActiveTasks(): boolean
  {
    return this.tasks.length > 0;
  }
}
